export default __webpack_public_path__ + "static/media/beeline-id.8947ee37.png";